module.exports = __webpack_public_path__ + "static/media/image-14.ce64a7f9.png";